module.exports = __webpack_public_path__ + "img/Logo2.9e301a21.png";